import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useIsSliderDecreaseSize } from './hooks';
import { Promotion, PromotionProps } from './Promotion';
import { NativeSlider } from '@/components/NativeSlider';
import { SliderArrow } from '@/components/NativeSlider/helpers';
import { useCommonStore } from '@/store';

import { ScSliderContainer } from './styled';

export const PromotionsSlider = () => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();
  const slides = useCommonStore.use.slides();

  const isSliderDecreaseSize = useIsSliderDecreaseSize();

  const sliderProps = useMemo(
    () => ({
      loop: true,
      pagination: true,
      arrows: !isMobileDevice ? { type: SliderArrow.INSIDE } : undefined,
      autoplay: {
        delay: 80000,
        pauseOnMouseEnter: true,
      },
    }),
    [isMobileDevice]
  );

  const slidesWithImageProps = useMemo<PromotionProps[]>(() => {
    return slides.map((slide, index) => ({
      ...slide,
      priority: index === 0,
      loading: index === 0 ? 'eager' : 'lazy',
    }));
  }, [slides]);

  return (
    <ScSliderContainer isSliderDecreaseSize={isSliderDecreaseSize}>
      {slides.length ? (
        <NativeSlider<PromotionProps>
          slides={slidesWithImageProps}
          slide={Promotion}
          {...sliderProps}
        />
      ) : null}
    </ScSliderContainer>
  );
};
